<ng-container *ngIf="vo$ | async; let vo">
	<span *ngIf="vo.isLoading" class="loading-spinner">
		<mat-spinner color="accent" [diameter]="vo.size"></mat-spinner>
	</span>
</ng-container>
